import { Icon } from '@sr/ui-library';
import { type RoyaltyFileDownload } from '../../../hooks/useRoyaltyFileDownload';
import {
  type StatementDownloadRow,
  type StatementFileName,
  type StatementFiles,
} from '../../../utils/helpers/statementFiles';
import { RoyaltyFileDownloadButton } from './RoyaltyFileDownloadButton';

/** Literal class names, so Tailwind generates both. */
const GAP_CLASS = { 2: 'gap-2', 4: 'gap-4' } as const;

/**
 * The PDF/CSV download pair on a statement or invoice row. Generic over the
 * file name so each data source's download hook only ever receives the names
 * its own endpoint serves.
 */
export const StatementDownloadButtons = <TFileName extends StatementFileName>({
  download: { handleDownload, isDownloading },
  files: { csv, pdf },
  gap = 4,
  row,
}: {
  download: RoyaltyFileDownload<TFileName>;
  files: StatementFiles<TFileName>;
  gap?: keyof typeof GAP_CLASS;
  row: Pick<StatementDownloadRow, '_id'>;
}) => (
  <div className={`flex items-center justify-center ${GAP_CLASS[gap]}`}>
    <RoyaltyFileDownloadButton
      aria-label="Download PDF"
      disabled={!pdf.available}
      loading={isDownloading(row._id, pdf.fileName)}
      sectionLeft={<Icon icon="filePdf" />}
      onClick={() => handleDownload(row._id, pdf.fileName, pdf.savedFileName)}
    />

    {csv && (
      <RoyaltyFileDownloadButton
        aria-label="Download CSV"
        disabled={!csv.available}
        loading={isDownloading(row._id, csv.fileName)}
        // TODO(APP-2200): CSV should use success green once design confirms.
        sectionLeft={<Icon icon="fileCsv" />}
        onClick={() => handleDownload(row._id, csv.fileName, csv.savedFileName)}
      />
    )}
  </div>
);
